import type { ObjectiveProgressStatus } from '@/interfaces/Objectives.interface';
import { ChipModes } from 'stubben-edge-unified-frontend-react-components';

export function progressToStatus(
  progressPercent: number
): ObjectiveProgressStatus {
  if (progressPercent <= 0) return 'not_started';
  if (progressPercent >= 70) return 'on_track';
  return 'at_risk';
}

export function statusLabel(status: ObjectiveProgressStatus): string {
  if (status === 'not_started') return 'Not started';
  if (status === 'at_risk') return 'At risk';
  return 'On track';
}

export function statusChipMode(status: ObjectiveProgressStatus) {
  if (status === 'not_started') return ChipModes.Grey;
  if (status === 'at_risk') return ChipModes.Yellow;
  return ChipModes.Green;
}

export function averageProgress(values: number[]): number {
  if (values.length === 0) return 0;
  const sum = values.reduce((acc, value) => acc + value, 0);
  return Math.round(sum / values.length);
}
